import { render, staticRenderFns } from "./ManualAssign.vue?vue&type=template&id=0139ae7e&scoped=true"
import script from "./ManualAssign.vue?vue&type=script&lang=js"
export * from "./ManualAssign.vue?vue&type=script&lang=js"
import style0 from "./ManualAssign.vue?vue&type=style&index=0&id=0139ae7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139ae7e",
  null
  
)

export default component.exports